export default {
  currency: {
    label: 'AUD',
  },
};
